import React, {useEffect} from 'react';
import {Title, TitleLevel, TitleSize, TitleColor} from 'components/ui/Title';
import Container from 'components/layout/Container';
import Checkmark from 'components/ui/icon/Checkmark';
import useAnalyticEvent from 'hooks/useAnalyticsEveent';

import './SpecialistsPage.scss';

function SpecialistsPage() {
  useAnalyticEvent('quick_view', {});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="specialists-page">
      <Container extraClassName="specialists-page__wrapper">
        <section className="specialists-page__section specialists-page__section_first">
          <Title
            extraClassName="specialists-page__section-title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
            color={TitleColor.black}
          >
            Мастера проходят строгий отбор
          </Title>

          <ul className="specialists-page__list">
            {[
              {
                title: <>Мастера опытные</>,
                description: (
                  <>
                    Мастера выполняют заказы по&nbsp;специализации больше года.
                  </>
                ),
              },
              {
                title: <>Мастера владеют профессиональным инструментом</>,
                description: (
                  <>
                    Инструмента достаточно для качественного решения задач
                    по&nbsp;специализации.
                  </>
                ),
              },
              {
                title: <>Мастера умеют общаться с&nbsp;клиентами</>,
                description: (
                  <>
                    Неконфликтные, разговаривают вежливо, не&nbsp;используют
                    в&nbsp;речи ругательные слова.
                  </>
                ),
              },
              {
                title: <>Мастера добропорядочные</>,
                description: (
                  <>
                    У&nbsp;мастеров нет и&nbsp;не&nbsp;было проблем
                    с&nbsp;законом.
                  </>
                ),
              },
            ].map((item, index) => (
              <li key={index} className="specialists-page__list-item">
                <Checkmark
                  extraClassName="specialists-page__list-item-bullet"
                  color="#00f"
                />

                <span className="specialists-page__list-item-title">
                  {item.title}
                </span>

                <span className="specialists-page__list-item-description">
                  {item.description}
                </span>
              </li>
            ))}
          </ul>
        </section>

        <section className="specialists-page__section specialists-page__section_second">
          <Title
            extraClassName="specialists-page__section-title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
            color={TitleColor.black}
          >
            Как мы&nbsp;отбираем мастеров
          </Title>

          <ul className="specialists-page__list">
            {[
              {
                title: <>Проверяем заявки</>,
                description: (
                  <>
                    Мастер, который хочет зарегистрироваться в&nbsp;сервисе,
                    отправляет заявку. По&nbsp;результатам проверки заявок
                    только 30&nbsp;из&nbsp;100 мастеров допускаются
                    до&nbsp;этапа видео-интервью.
                  </>
                ),
              },
              {
                title: <>Проводим видео-интервью</>,
                description: (
                  <>
                    Мы&nbsp;задаём мастеру вопросы о&nbsp;профессиональном
                    опыте, об&nbsp;опыте общения с&nbsp;клиентами,
                    о&nbsp;подходах к&nbsp;работе. Проверяем мастера
                    на&nbsp;склонность к&nbsp;конфликтам, уверенное знание
                    своего дела и&nbsp;связанных с&nbsp;ним особенностей, узнаём
                    о&nbsp;реальном опыте мастера. Только
                    7&nbsp;из&nbsp;10&nbsp;мастеров проходят это интервью
                    успешно.
                  </>
                ),
              },
              {
                title: <>Проверяем документы мастеров</>,
                description: (
                  <>
                    Мы&nbsp;проверяем паспорт и&nbsp;прописку исполнителей. Если
                    мастер гражданин другого государства и&nbsp;планирует
                    с&nbsp;нами сотрудничать регулярно, запросим миграционную
                    карту, разрешение на&nbsp;работу или патент, разрешение
                    на&nbsp;временное проживание или вид на&nbsp;жительство.
                    Только половина мастеров, дошедших до&nbsp;этапа проверки,
                    проходят его и&nbsp;подключаются к&nbsp;заказам.
                  </>
                ),
              },
            ].map((item, index) => (
              <li key={index} className="specialists-page__list-item">
                <span className="specialists-page__list-item-bullet specialists-page__list-item-bullet_number">
                  {index + 1}.
                </span>

                <span className="specialists-page__list-item-title">
                  {item.title}
                </span>

                <span className="specialists-page__list-item-description">
                  {item.description}
                </span>
              </li>
            ))}
          </ul>
        </section>

        <section className="specialists-page__section specialists-page__section_third">
          <Title
            extraClassName="specialists-page__section-title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
            color={TitleColor.black}
          >
            Результаты работ под контролем
          </Title>

          <p className="specialists-page__section-description">
            Пройдя все этапы, мастер получает допуск к&nbsp;заказам,
            а&nbsp;мы&nbsp;начинаем за&nbsp;ним пристально наблюдать.
            На&nbsp;всём протяжении сотрудничества с&nbsp;мастером
            мы&nbsp;контролируем отзывы о&nbsp;его работе. По&nbsp;отзывам
            отслеживаем профессионализм и&nbsp;дисциплину. По&nbsp;фотоотчётам
            с&nbsp;заказов контролируем выполнение требований к&nbsp;технологии
            и&nbsp;результату работ.
          </p>

          <p className="specialists-page__section-disclaimer">
            Сервис РУКИ подбирает частного мастера, но&nbsp;не&nbsp;является
            исполнителем работ. Ознакомьтесь с&nbsp;
            <a
              href="https://hands.ru/documents/terms-of-use-service-ruki/"
              target="_blank"
              rel="noreferrer"
            >
              условиями использования Сервиса Руки
            </a>
          </p>
        </section>
      </Container>
    </main>
  );
}

export default SpecialistsPage;
